import { useEffect, useState } from "react";
import classes from "./BlogSidebar.module.scss";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaXingSquare,
  FaLinkedinIn,
  FaTiktok,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import axios from "../../../requests/axios";
import routes from "../../../requests/routes";
import FeaturedBlogCard from "../../../generic components/main blog card/MainBlogCard";
import { Image } from "antd";

const socials = [
  {
    id: "instagram",
    name: "Instagram",
    icon: FaInstagram,
    href: "https://www.instagram.com/have.adream/",
  },
  {
    id: "x",
    name: "X(Twitter)",
    icon: FaXTwitter,
    href: "https://x.com/yourhandle",
  },
  {
    id: "facebook",
    name: "Facebook",
    icon: FaFacebookF,
    href: "https://www.facebook.com/haveadream.org/",
  },
  {
    id: "youtube",
    name: "Youtube",
    icon: FaYoutube,
    href: "https://www.youtube.com/user/HaveADreamOrg#:~:text=Have%20A%20Dream%20is%20an%20organization",
  },
  {
    id: "tiktok",
    name: "TikTok",
    icon: FaTiktok,
    href: "https://www.tiktok.com/@haveadreamorg",
  },
  {
    id: "linkedin",
    name: "Linkedin",
    icon: FaLinkedinIn,
    href: "https://www.linkedin.com/company/have-a-dream-organization/about/",
  },
];

export const BlogSidebar = ({ author }) => {
  const [fblogs, setfblogs] = useState([]);
  const [hasLoaded, setHasLoaded] = useState(false);

  const getFblogs = async () => {
    try {
      const response = await axios.get(routes.getFblogs);
      setfblogs(response.data.blogs);
      setHasLoaded(true);
    } catch (err) {}
  };
  useEffect(() => {
    getFblogs();
  }, []);

  return (
    <div className={classes.blog}>
      <div className={classes.blog__sidebar}>
        {author && (
          <div className={classes.blog__sidebar__wrapper}>
            <div className={classes.blog__sidebar__wrapper__title}>
              <p>About Me</p>

              <div className={`${classes.author}`}>
                <div className={`${classes.author__image}`}>
                  <Image
                    width={"100%"}
                    className={classes.Image}
                    src={author.image}
                    alt={author.fullName}
                  />
                </div>
                <div className={`${classes.author__details}`}>
                  <div className={`${classes.author__details__name}`}>
                    {author.fullName}
                  </div>
                  <div className={`${classes.author__details__nationality}`}>
                    {author.nationality}
                  </div>
                  <div className={`${classes.author__details__email}`}>
                    {author.email}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className={classes.blog__sidebar__wrapper}>
          <div className={classes.blog__sidebar__wrapper__title}>
            <p>Social Networks</p>
          </div>

          <div className={`${classes.socials}`}>
            <ul className={`${classes.socials__grid}`} role="list">
              {socials.map(({ id, name, icon: Icon, href }) => (
                <li
                  key={id}
                  className={`${classes.card} ${classes[`card--${id}`] || ""}`}
                >
                  <a
                    className={`${classes.card__link}`}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span
                      className={`${classes.card__badge}`}
                      aria-hidden="true"
                    >
                      <Icon size={20} />
                    </span>
                    <span className={`${classes.card__name}`}>{name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className={classes.blog__sidebar__wrapper}>
          <div className={classes.blog__sidebar__wrapper__title}>
            <p>Featured Posts</p>
          </div>
          {fblogs.map((value) => {
            let day = value.publishDate.slice(0, 10);
            return (
              <FeaturedBlogCard
                key={value._id}
                id={value._id}
                image={value.image || value.coverImage}
                title={value.title}
                date={day}
                content={value.content}
                author={value.author}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BlogSidebar;
